export const api = {
  downloadTemplate: '/receipts/download-template',
  uploadTemplate: '/receipts/upload-receipt-file',
  processTemplate: '/receipts/process-receipt-file',
  generalReceipt: '/receipt',
  generalReceiptCancellation: '/receipt-cancellation',
  generalReceiptDownload: '/receipt/download',
}
